export const SEO = {
  title: "Karan Desai - Software Developer + Freelancer",
  url: "https://portfolio-rho-seven-10.vercel.app/",
  description: "",
  siteName: "https://karan-portfolio-six.vercel.app/",
  github: "https://github.com/karandesai24/",
  avatar:
    "https://avatars.githubusercontent.com/u/78134745?u=15e7998f99a9759ef9ad24af31686cf65183828a&v=4",
  author: "Karan Desai",
  openGraph: {
    type: "website",
    locale: "en_US",
    url: "https://karan-portfolio-six.vercel.app/",
    site_name: "https://karan-portfolio-six.vercel.app/",
    title: "Karan Desai",
    description: "",
    images: [
      {
        url: "https://avatars.githubusercontent.com/u/78134745?u=15e7998f99a9759ef9ad24af31686cf65183828a&v=4",
        alt: "Karan Desai - Software Engineer",
        width: 1200,
        height: 630,
      },
    ],
  },
};
